// SQLITE IMPORTS
import { Plugins } from "@capacitor/core";
import { SQLiteConnection } from "@capacitor-community/sqlite";

// JSON FILE WITH DATA
import jsonData from "./import-json";

const { CapacitorSQLite } = Plugins;

const mSQLite = new SQLiteConnection(CapacitorSQLite);
let database: any;

//Si no existe daatabase se crea y se importa el json

const loadJSON = async () => {
    return await mSQLite.importFromJson(JSON.stringify(jsonData));
};

//se inicializa la base de datos

export const initdb = async () => {
    try {

        const ret = await mSQLite.checkConnectionsConsistency()
        const isConn = (await mSQLite.isConnection('ariposappdb', false)).result

        if (ret.result && isConn) {
            database = await mSQLite.retrieveConnection("ariposappdb", false)
        } else {
            database = await mSQLite.createConnection(
                "ariposappdb",
                false,
                "no-encryption",
                1, false
            );
            // load the default contacts
            await loadJSON();

        }

        return database

    } catch (e) {
        //window.alert(e);
        console.log(e);
        return null;
    }
};

//-------------------------------------se generan consultas a la base de datos

//LOCACIONES

export const queryAllLocations = async () => {
    const ret = await mSQLite.checkConnectionsConsistency()
    const isConn = (await mSQLite.isConnection('ariposappdb', false)).result;

    if (ret.result && isConn) {
        // open database
        await database.open();
        return database.query("SELECT * from locations order by id desc;");
    }

};

export const createLocationTest = async () => {
    if (!database) {
        await initdb();
    }
    return await database.run(
        "INSERT INTO locations (id, lat, lng, datetime) VALUES( ?, ?, ?, ?)",
        [
            null,
            '12.11966704341231',
            '-86.23124409076823',
            'test'
        ]
    );
};

//CONFIGURACION

export const createConfiguration = async (data: any) => {
    if (!database) {
        await initdb();
    }
    return await database.run(
        "INSERT INTO configurations (id, token, data_login) VALUES( ?, ?, ?)",
        [
            null,
            data.token,
            data.data_login,
        ]
    );
};

export const updateConfigurationById = async (id: any, data: any) => {
    if (!database) {
        await initdb();
    }
    return await database.query(
        "UPDATE configurations SET token =?, data_login =? WHERE id = ?;",
        [
            data.token,
            data.data_login,
            id + ""
        ]
    );
};

export const deleteConfigurationById = async (id: any) => {
    if (!database) {
        await initdb();
    }
    return await database.query("DELETE FROM configurations WHERE id = ?;", [
        id + ""
    ]);

};

export const getConfigurationById = async (id: any) => {
    if (!database) {
        await initdb();
    }
    await database.open();
    return await database.query("SELECT * FROM configurations WHERE id = ?;", [
        id + "",
    ]);

};

export const queryAllConfiguration = async () => {
    const ret = await mSQLite.checkConnectionsConsistency()
    const isConn = (await mSQLite.isConnection('ariposappdb', false)).result;

    if (ret.result && isConn) {
        // open database
        await database.open();
        return database.query("SELECT * from configurations order by id desc;");
    }

};

//PERMISSIONS

export const queryAllPermisions = async () => {
    const ret = await mSQLite.checkConnectionsConsistency()
    const isConn = (await mSQLite.isConnection('ariposappdb', false)).result;

    if (ret.result && isConn) {
        // open database
        await database.open();
        return database.query("SELECT * from permissions order by id desc;");
    }

};


export const createPermission = async () => {
    if (!database) {
        await initdb();
    }
    return await database.run(
        "INSERT INTO permissions (id, name, status) VALUES( ?, ?, ?)",
        [
            null,
            'permiso2',
            'desactive',
        ]
    );
};

//ACTIVITIES
export const createActivitie = async (data: any) => {
    if (!database) {
        await initdb();
    }
    return await database.run(
        "INSERT INTO activities (id, log_name, description, date, user_id, other) VALUES( ?, ?, ?,?, ?, ?)",
        [
            null,
            data.log_name,
            data.description,
            data.date,
            data.user_id,
            ''
        ]
    );
};
export const queryAllActivities = async () => {
    const ret = await mSQLite.checkConnectionsConsistency()
    const isConn = (await mSQLite.isConnection('ariposappdb', false)).result;

    if (ret.result && isConn) {
        // open database
        await database.open();
        return database.query("SELECT * from activities order by id desc;");
    }

};

const ensureProductsOfflineTable = async () => {
    if (!database) {
        await initdb();
    }

    await database.open();

    const tableExists = await database.query(
        "SELECT name FROM sqlite_master WHERE type='table' AND name='products_offline';"
    );

    if (!tableExists.values || tableExists.values.length === 0) {
        await database.execute(`
            CREATE TABLE IF NOT EXISTS products_offline (
                id INTEGER PRIMARY KEY,
                product_id INTEGER,
                name TEXT,
                type TEXT,
                quantity REAL,
                current_price REAL,
                current_price_discount REAL,
                discount_amount REAL,
                discount_type TEXT,
                enable_stock INTEGER,
                unit_id INTEGER,
                factor REAL,
                product_image TEXT,
                variation TEXT,
                qty_available REAL,
                default_sell_price REAL,
                sub_sku TEXT,
                dpp_inc_tax REAL,
                variation_group_price REAL,
                sub_units TEXT,
                data_price_group TEXT
            );
        `);
    }

    const productColumns = await database.query("PRAGMA table_info(products_offline);");
    const productColumnNames = (productColumns.values || []).map((column: any) => column.name);

    if (!productColumnNames.includes('data_price_group')) {
        await database.execute("ALTER TABLE products_offline ADD COLUMN data_price_group TEXT;");
    }
};

export const queryAllProductsOffline = async () => {
    await ensureProductsOfflineTable();
    return database.query("SELECT * from products_offline order by name asc;");
};

export const clearProductsOffline = async () => {
    await ensureProductsOfflineTable();
    await database.run("DELETE FROM products_offline;");
};

export const replaceAllProductsOfflineWithProgress = async (
    products: any[] = [],
    onProgress?: (processed: number, total: number) => void
) => {
    await ensureProductsOfflineTable();
    await clearProductsOffline();

    const total = products.length;
    if (onProgress) {
        onProgress(0, total);
    }

    let processed = 0;

    for (const product of products) {
        await database.run(
            "INSERT OR REPLACE INTO products_offline (id, product_id, name, type, quantity, current_price, current_price_discount, discount_amount, discount_type, enable_stock, unit_id, factor, product_image, variation, qty_available, default_sell_price, sub_sku, dpp_inc_tax, variation_group_price, sub_units, data_price_group) VALUES(?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)",
            [
                product.id ?? null,
                product.product_id ?? null,
                product.name ?? '',
                product.type ?? '',
                product.quantity ?? 1,
                product.current_price ?? 0,
                product.current_price_discount ?? 0,
                product.discount_amount ?? 0,
                product.discount_type ?? 'fixed',
                product.enable_stock ? 1 : 0,
                product.unit_id ?? null,
                product.factor ?? 0,
                product.product_image ?? '',
                product.variation ?? '',
                product.qty_available ?? 0,
                product.default_sell_price ?? 0,
                product.sub_sku ?? '',
                product.dpp_inc_tax ?? 0,
                product.variation_group_price ?? 0,
                JSON.stringify(product.sub_units ?? []),
                JSON.stringify(product.data_price_group ?? [])
            ]
        );

        processed += 1;
        if (onProgress && (processed === total || processed % 25 === 0)) {
            onProgress(processed, total);
        }
    }

    return database.query("SELECT COUNT(*) as total FROM products_offline;");
};

export const replaceAllProductsOffline = async (products: any[] = []) => {
    return replaceAllProductsOfflineWithProgress(products);
};

const ensureCustomersOfflineTable = async () => {
    if (!database) {
        await initdb();
    }

    await database.open();

    const tableExists = await database.query(
        "SELECT name FROM sqlite_master WHERE type='table' AND name='customers_offline';"
    );

    if (!tableExists.values || tableExists.values.length === 0) {
        await database.execute(`
            CREATE TABLE IF NOT EXISTS customers_offline (
                id INTEGER PRIMARY KEY,
                contact_id TEXT,
                name TEXT,
                mobile TEXT,
                type TEXT,
                customer_group_id INTEGER,
                supplier_business_name TEXT,
                selling_price_group_id INTEGER,
                server_contact_db_id INTEGER,
                is_local_created INTEGER DEFAULT 0
            );
        `);
    }

    const customerColumns = await database.query("PRAGMA table_info(customers_offline);");
    const customerColumnNames = (customerColumns.values || []).map((column: any) => column.name);

    if (!customerColumnNames.includes('supplier_business_name')) {
        await database.execute("ALTER TABLE customers_offline ADD COLUMN supplier_business_name TEXT;");
    }

    if (!customerColumnNames.includes('selling_price_group_id')) {
        await database.execute("ALTER TABLE customers_offline ADD COLUMN selling_price_group_id INTEGER;");
    }

    if (!customerColumnNames.includes('mobile')) {
        await database.execute("ALTER TABLE customers_offline ADD COLUMN mobile TEXT;");
    }

    if (!customerColumnNames.includes('server_contact_db_id')) {
        await database.execute("ALTER TABLE customers_offline ADD COLUMN server_contact_db_id INTEGER;");
    }

    if (!customerColumnNames.includes('is_local_created')) {
        await database.execute("ALTER TABLE customers_offline ADD COLUMN is_local_created INTEGER DEFAULT 0;");
    }
};

export const queryAllCustomersOffline = async () => {
    await ensureCustomersOfflineTable();
    return database.query("SELECT * from customers_offline order by name asc;");
};

export const clearCustomersOffline = async () => {
    await ensureCustomersOfflineTable();
    await database.run("DELETE FROM customers_offline;");
};

export const createCustomerOffline = async (customer: any) => {
    await ensureCustomersOfflineTable();

    const result = await database.run(
        "INSERT INTO customers_offline (id, contact_id, name, mobile, type, customer_group_id, supplier_business_name, selling_price_group_id, server_contact_db_id) VALUES(?, ?, ?, ?, ?, ?, ?, ?, ?)",
        [
            null,
            customer.contact_id ?? `OFF-${Date.now()}`,
            customer.name ?? '',
            customer.mobile ?? '',
            customer.type ?? 'customer',
            customer.customer_group_id ?? null,
            customer.supplier_business_name ?? '',
            customer.selling_price_group_id ?? null,
            null,
        ]
    );

    if (result?.changes?.lastId) {
        await database.run(
            "UPDATE customers_offline SET is_local_created = 1 WHERE id = ?",
            [result.changes.lastId]
        );
    }

    return result?.changes?.lastId ?? null;
};

export const replaceAllCustomersOfflineWithProgress = async (
    customers: any[] = [],
    onProgress?: (processed: number, total: number) => void
) => {
    await ensureCustomersOfflineTable();
    await clearCustomersOffline();

    const total = customers.length;
    if (onProgress) {
        onProgress(0, total);
    }

    let processed = 0;

    for (const customer of customers) {
        await database.run(
            "INSERT OR REPLACE INTO customers_offline (id, contact_id, name, mobile, type, customer_group_id, supplier_business_name, selling_price_group_id, server_contact_db_id, is_local_created) VALUES(?, ?, ?, ?, ?, ?, ?, ?, ?, ?)",
            [
                customer.id ?? null,
                customer.contact_id ?? '',
                customer.name ?? '',
                customer.mobile ?? '',
                customer.type ?? 'customer',
                customer.customer_group_id ?? null,
                customer.supplier_business_name ?? '',
                customer.selling_price_group_id ?? null,
                customer.id ?? null,
                0,
            ]
        );

        processed += 1;
        if (onProgress && (processed === total || processed % 25 === 0)) {
            onProgress(processed, total);
        }
    }

    return database.query("SELECT COUNT(*) as total FROM customers_offline;");
};

export const replaceAllCustomersOffline = async (customers: any[] = []) => {
    return replaceAllCustomersOfflineWithProgress(customers);
};

const ensureOfflineInvoicesTables = async () => {
    if (!database) {
        await initdb();
    }

    await database.open();

    await database.execute(`
        CREATE TABLE IF NOT EXISTS offline_invoices (
            id INTEGER PRIMARY KEY AUTOINCREMENT,
            local_uuid TEXT,
            contact_id INTEGER,
            customer_name TEXT,
            status_sale TEXT,
            total REAL,
            location_id INTEGER,
            notes TEXT,
            payload_json TEXT,
            status_sync TEXT,
            server_response TEXT,
            server_transaction_id TEXT,
            error_message TEXT,
            created_at TEXT,
            updated_at TEXT
        );
    `);

    await database.execute(`
        CREATE TABLE IF NOT EXISTS offline_invoice_lines (
            id INTEGER PRIMARY KEY AUTOINCREMENT,
            invoice_id INTEGER,
            variation_id INTEGER,
            product_id INTEGER,
            product_name TEXT,
            sku TEXT,
            qty REAL,
            unit_price REAL,
            unit_price_inc_tax REAL,
            discount_type TEXT,
            discount_amount REAL,
            unit_id INTEGER,
            dpp_inc_tax REAL,
            enable_stock INTEGER,
            product_type TEXT,
            line_json TEXT
        );
    `);

    const invoiceColumns = await database.query("PRAGMA table_info(offline_invoices);");
    const invoiceColumnNames = (invoiceColumns.values || []).map((column: any) => column.name);

    if (!invoiceColumnNames.includes('status_sync')) {
        await database.execute("ALTER TABLE offline_invoices ADD COLUMN status_sync TEXT;");
    }

    if (!invoiceColumnNames.includes('server_response')) {
        await database.execute("ALTER TABLE offline_invoices ADD COLUMN server_response TEXT;");
    }

    if (!invoiceColumnNames.includes('server_transaction_id')) {
        await database.execute("ALTER TABLE offline_invoices ADD COLUMN server_transaction_id TEXT;");
    }

    if (!invoiceColumnNames.includes('error_message')) {
        await database.execute("ALTER TABLE offline_invoices ADD COLUMN error_message TEXT;");
    }
};

const insertOfflineInvoiceLines = async (invoiceId: number, lines: any[] = []) => {
    for (const line of lines) {
        await database.run(
            "INSERT INTO offline_invoice_lines (invoice_id, variation_id, product_id, product_name, sku, qty, unit_price, unit_price_inc_tax, discount_type, discount_amount, unit_id, dpp_inc_tax, enable_stock, product_type, line_json) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)",
            [
                invoiceId,
                line.variation_id ?? null,
                line.product_id ?? null,
                line.product_name ?? '',
                line.sku ?? '',
                line.qty ?? 0,
                line.unit_price ?? 0,
                line.unit_price_inc_tax ?? 0,
                line.discount_type ?? 'fixed',
                line.discount_amount ?? 0,
                line.unit_id ?? null,
                line.dpp_inc_tax ?? 0,
                line.enable_stock ? 1 : 0,
                line.product_type ?? 'single',
                JSON.stringify(line || {})
            ]
        );
    }
};

export const createOfflineInvoice = async (invoice: any, lines: any[] = []) => {
    await ensureOfflineInvoicesTables();

    const now = new Date().toISOString();
    const result = await database.run(
        "INSERT INTO offline_invoices (local_uuid, contact_id, customer_name, status_sale, total, location_id, notes, payload_json, status_sync, server_response, server_transaction_id, error_message, created_at, updated_at) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)",
        [
            invoice.local_uuid ?? `offline_${Date.now()}`,
            invoice.contact_id ?? null,
            invoice.customer_name ?? '',
            invoice.status_sale ?? 'quotation',
            invoice.total ?? 0,
            invoice.location_id ?? null,
            invoice.notes ?? '',
            JSON.stringify(invoice.payload || {}),
            invoice.status_sync ?? 'pending',
            invoice.server_response ?? '',
            invoice.server_transaction_id ?? null,
            invoice.error_message ?? '',
            now,
            now,
        ]
    );

    const invoiceId = result?.changes?.lastId;
    if (invoiceId) {
        await insertOfflineInvoiceLines(invoiceId, lines);
    }

    return invoiceId;
};

export const updateOfflineInvoice = async (invoiceId: number, invoice: any, lines: any[] = []) => {
    await ensureOfflineInvoicesTables();

    const now = new Date().toISOString();
    await database.run(
        "UPDATE offline_invoices SET contact_id = ?, customer_name = ?, status_sale = ?, total = ?, location_id = ?, notes = ?, payload_json = ?, status_sync = ?, server_response = ?, server_transaction_id = ?, error_message = ?, updated_at = ? WHERE id = ?",
        [
            invoice.contact_id ?? null,
            invoice.customer_name ?? '',
            invoice.status_sale ?? 'quotation',
            invoice.total ?? 0,
            invoice.location_id ?? null,
            invoice.notes ?? '',
            JSON.stringify(invoice.payload || {}),
            invoice.status_sync ?? 'pending',
            invoice.server_response ?? '',
            invoice.server_transaction_id ?? null,
            invoice.error_message ?? '',
            now,
            invoiceId,
        ]
    );

    await database.query("DELETE FROM offline_invoice_lines WHERE invoice_id = ?;", [invoiceId]);
    await insertOfflineInvoiceLines(invoiceId, lines);

    return true;
};

export const queryAllOfflineInvoices = async () => {
    await ensureOfflineInvoicesTables();

    return database.query(`
        SELECT
            i.*,
            (SELECT COUNT(*) FROM offline_invoice_lines l WHERE l.invoice_id = i.id) AS lines_total
        FROM offline_invoices i
        ORDER BY i.id DESC;
    `);
};

export const queryOfflineInvoiceById = async (invoiceId: number) => {
    await ensureOfflineInvoicesTables();
    return database.query("SELECT * FROM offline_invoices WHERE id = ? LIMIT 1;", [invoiceId]);
};

export const queryOfflineInvoiceLines = async (invoiceId: number) => {
    await ensureOfflineInvoicesTables();
    return database.query("SELECT * FROM offline_invoice_lines WHERE invoice_id = ? ORDER BY id ASC;", [invoiceId]);
};

export const markOfflineInvoiceSyncStatus = async (
    invoiceId: number,
    statusSync: 'pending' | 'synced' | 'error' | 'syncing',
    serverResponse: string = '',
    serverTransactionId: string | null = null,
    errorMessage: string = ''
) => {
    await ensureOfflineInvoicesTables();

    await database.run(
        "UPDATE offline_invoices SET status_sync = ?, server_response = ?, server_transaction_id = ?, error_message = ?, updated_at = ? WHERE id = ?",
        [
            statusSync,
            serverResponse,
            serverTransactionId,
            errorMessage,
            new Date().toISOString(),
            invoiceId,
        ]
    );

    return true;
};

export const deleteOfflineInvoice = async (invoiceId: number) => {
    await ensureOfflineInvoicesTables();

    await database.query("DELETE FROM offline_invoice_lines WHERE invoice_id = ?;", [invoiceId]);
    await database.query("DELETE FROM offline_invoices WHERE id = ?;", [invoiceId]);

    return true;
};

export const queryLocalCreatedCustomersOffline = async () => {
    await ensureCustomersOfflineTable();
    return database.query("SELECT * FROM customers_offline WHERE is_local_created = 1 ORDER BY id ASC;");
};

export const deleteCustomerOfflineById = async (customerId: number) => {
    await ensureCustomersOfflineTable();
    await database.query("DELETE FROM customers_offline WHERE id = ?;", [customerId]);
    return true;
};

export const updateCustomerOfflineAfterSync = async (
    localCustomerId: number,
    serverContactDbId: number,
    serverContactCode: string
) => {
    await ensureCustomersOfflineTable();

    await database.run(
        "UPDATE customers_offline SET contact_id = ?, server_contact_db_id = ?, is_local_created = 0 WHERE id = ?",
        [
            serverContactCode,
            serverContactDbId,
            localCustomerId,
        ]
    );

    return true;
};